/**
 * How a hero-diagram mark moves between states: it lights up quickly when a
 * node or path becomes active, and lets go slowly when it stops being.
 */
export function heroTransition(active: boolean): string {
  return active
    ? "transition-all duration-250 ease-out"
    : "transition-all duration-1500 ease-[cubic-bezier(0.16,1,0.3,1)]";
}
